import _Popover from './Panel';
import Confirm from './Confirm';
import Content from './Content';
var Popover = _Popover;
Popover.displayName = 'ShineoutPopover';
Popover.Confirm = Confirm;
Popover.Confirm.displayName = 'ShineoutPopoverConfirm';
Popover.Content = Content;
Popover.Content.displayName = 'ShineoutPopoverContent';
export default Popover;